var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.38086 10C2.89939 10.9124 3.64547 11.6701 4.544 12.1967C5.44253 12.7234 6.46183 13.0004 7.49931 13C8.5368 13.0004 9.55609 12.7234 10.4546 12.1967C11.3532 11.6701 12.0992 10.9124 12.6178 10M2.38086 4C2.89939 3.08757 3.64547 2.32991 4.544 1.80326C5.44253 1.27662 6.46183 0.999573 7.49931 1C8.5368 0.999573 9.55609 1.27662 10.4546 1.80326C11.3532 2.32991 12.0992 3.08757 12.6178 4",
    stroke: "#808282",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09091 12.9693C8.09091 12.9693 8.92291 11.8575 9.44705 9.9993M8.09091 1.0293C8.09091 1.0293 8.92291 2.1405 9.44705 3.9993M6.90909 12.9693C6.90909 12.9693 6.07709 11.8581 5.55295 9.9993M6.90909 1.0293C6.90909 1.0293 6.07709 2.1405 5.55295 3.9993M5.72727 5.7993L6.61364 8.7993L7.5 5.7993L8.38636 8.7993L9.27273 5.7993M1 5.7993L1.88636 8.7993L2.77273 5.7993L3.65909 8.7993L4.54545 5.7993M10.4545 5.7993L11.3409 8.7993L12.2273 5.7993L13.1136 8.7993L14 5.7993",
    stroke: "#808282",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/Website.2adf3836d9903f176b58120adae7a85a.svg";
export { ForwardRef as ReactComponent };